import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';
import Home from "./Pages/Home";
import Notfound from "./Components/Notfound";
import Services from "./Pages/Services";
import Askrate from "./Pages/Askrate";
import Contact from "./Pages/Contact";
import Aboutus from "./Pages/Aboutus"


function App() {
  return (
    // router
    <Router>
      <Routes>
        <Route exact path="/" element={<Home/>} />
        <Route
          exact
          path="/services"
          element={<Services/>}
        />
        <Route
          exact
          path="/askrate"
          element={<Askrate/>}
        />
        <Route
          exact
          path="/contact"
          element={<Contact/>}
        />
         <Route
          exact
          path="/aboutus"
          element={<Aboutus/>}
        />
        <Route path="*" element={<Notfound/>} />
      </Routes>
    </Router>
  );
}

export default App;
